import { render, staticRenderFns } from "./SelecionarDominio.vue?vue&type=template&id=5eb50230&scoped=true"
import script from "./SelecionarDominio.vue?vue&type=script&lang=js"
export * from "./SelecionarDominio.vue?vue&type=script&lang=js"
import style0 from "./SelecionarDominio.vue?vue&type=style&index=0&id=5eb50230&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb50230",
  null
  
)

export default component.exports